module.exports = __webpack_public_path__ + "img/index.11939fa6.jpg";